import { BankAccountDetails, CardDetails, CashAppPayDetail, Money, PaymentCardDetails } from '@afterpay/types'
import { CardDefaultValue } from '@afterpaytouch/form/lib/types'
import { PaymentArrangementSchedule } from '@afterpaytouch/portal-api/consumer/hardship/types'
import { OrderFeeResponse, OrderPaymentSchedule } from '@afterpaytouch/portal-api/consumer/ordertransactions/types'
import { PaymentMethodType } from '@afterpaytouch/portal-api/types'

export enum OrderFeeType {
  FIRST = 'FIRST',
  SECOND = 'SECOND',
  FAILED_PAYMENT = 'FAILED_PAYMENT_FEE',
}

export interface OrderFeeResponseWithType extends OrderFeeResponse {
  feeType?: OrderFeeType | string | null
}

type Card = CardDetails | PaymentCardDetails | CardDefaultValue

export type PaymentMethods = Card | PaymentMethodType.APPLE_PAY | BankAccountDetails | CashAppPayDetail

export interface PayNowScheduleOption {
  selected: boolean
  id: number
  schedule?: OrderPaymentSchedule | PaymentArrangementSchedule
  payoutAmount?: Money
  index?: number
}

export enum PayNowInputTypes {
  Checkbox = 'Checkbox',
  Radio = 'Radio',
}
